enum DirectoryEvents {
    // ディレクトリ一覧取得
    GetDirStarted = "[DirectoryEvents] GetDirStarted",
    GetDirComplete = "[DirectoryEvents] GetDirComplete",

    // ディレクトリ作成
    CreateDirStarted = "[DirectoryEvents] CreateDirStarted",
    CreateDirComplete = "[DirectoryEvents] CreateDirComplete",

    // ディレクトリ名変更
    RenameDirStarted = "[DirectoryEvents] RenameDirStarted",
    RenameDirComplete = "[DirectoryEvents] RenameDirComplete",

    // ディレクトリ削除
    DeleteDirStarted = "[DirectoryEvents] DeleteDirStarted",
    DeleteDirComplete = "[DirectoryEvents] DeleteDirComplete",

    // フッテージアップロード
    UploadFootageStarted = "[DirectoryEvents] UploadFootageStarted",
    UploadFootageComplete = "[DirectoryEvents] UploadFootageComplete",

    // フッテージ名変更
    RenameFootageStarted = "[DirectoryEvents] RenameFootageStarted",
    RenameFootageComplete = "[DirectoryEvents] RenameFootageComplete",

    // フッテージ削除
    DeleteFootageStarted = "[DirectoryEvents] DeleteFootageStarted",
    DeleteFootageComplete = "[DirectoryEvents] DeleteFootageComplete",
    DeleteFootageFailed = "[DirectoryEvents] DeleteFootageFailed",
    ResetDeleteError = "[DirectoryEvents] ResetDeleteError",
}

export default DirectoryEvents;
